import { render, staticRenderFns } from "./guardian-messages.vue?vue&type=template&id=6970e2cd"
import script from "./guardian-messages.ts?vue&type=script&lang=js&external"
export * from "./guardian-messages.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports